import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import $ from 'jquery';

// import 'datatables.net-dt/css/jquery.dataTables.min.css';
// import 'datatables.net-buttons/js/dataTables.buttons.min';
// import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
// $.DataTable = require('datatables.net');
// require('datatables.net-responsive');
// require('datatables.net-buttons/js/buttons.html5.min');

const columns = [
  {
    title: 'รหัสสัญญา',
    data: 'CONTRACT_FOR_CAL',
  },
  {
    title: 'ชื่อสัญญา',
    data: 'CONTRACT_NAME',
  },
  {
    title: 'VIEW',
    data: 'PATHV2', // ใช้รหัสสัญญาแทน
    render: function (data, type, row) {
      if (type === 'display') {
        // return `
        //   <button class="btn btn-outline-secondary btn-sm view-contract" data-contract="${row.CONTRACT_FOR_CAL}" data-path="${row.PATHV2}">
        //     <i class="fas fa-search"></i>
        //   </button>`;
        return `
        <a class="btn btn-outline-secondary btn-sm view-contract" target="_blank" href="${row.PATHV2}">
          <i class="fas fa-search"></i>
        </a>`;
      }
      return data;
    }
  }
];

class TableMyContract extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const table = $(`#contractTable`).DataTable({
      data: this.props.items,
      dom: 'Bfrtip',
      columns,
      searching: true,
      order: [[0, 'asc']], // เรียงตามรหัสสัญญา
      paging: true,
      ordering: true,
      autoWidth: true,
      bDestroy: true,
      pageLength: 10,
      scrollX: true,
      buttons: ['copy', 'csv', 'excelHtml5'],
    });

    // Event Listener สำหรับปุ่ม View
    $(`#contractTable tbody`).on('click', '.view-contract', (event) => {
      const button = $(event.currentTarget);
      const contractData = {
        // CONTRACT_FOR_CAL: button.data('contract'),
        PATHV2: button.data('path'),
      };

      // this.props.onViewContract(contractData); // เปิดเอกสาร
    });
  }

  componentWillUnmount() {
    $(`#contractTable`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    const table = $(`#contractTable`).DataTable();
    table.clear();
    table.rows.add(nextProps.items);
    table.draw();
    return false;
  }

  render() {
    return (
      <div>
        <Card className="card-primary">
          <Card.Header>รายการสัญญาทั้งหมด</Card.Header>
          <Card.Body>
            <table
              id="contractTable"
              className="display nowrap example"
              style={{ width: '100%' }}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default TableMyContract;
